export * from './keywords-score.interface';
